module.exports = __webpack_public_path__ + "img/image7.bdd4f333.png";